import { Box } from 'components/ui';
import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';

function Icon({
    display = 'inline-block',
    width = '1em',
    height = '1em',
    position = 'relative',
    verticalAlign = 'text-bottom',
    fill = 'currentColor',
    flexShrink = 0,
    ['aria-hidden']: ariaHidden = true,
    ...props
}) {
    return (
        <Box
            display={display}
            width={width}
            height={height}
            position={position}
            verticalAlign={verticalAlign}
            fill={fill}
            flexShrink={flexShrink}
            aria-hidden={ariaHidden}
            {...props}
            is='svg'
        />
    );
}

export default wrapFunctionalComponent(Icon, 'Icon');
